import { __decorate, __metadata } from "tslib";
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
export const messagingStoreModuleName = 'messagingStore';
let MessagingModule = class MessagingModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.iFrameVisibility = '';
    }
    get visibility() {
        return this.iFrameVisibility;
    }
    setVisibility(visibility) {
        this.iFrameVisibility = visibility;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MessagingModule.prototype, "setVisibility", null);
MessagingModule = __decorate([
    Module({
        name: messagingStoreModuleName,
        namespaced: true,
        stateFactory: true,
    })
], MessagingModule);
export { MessagingModule };
